<template>
    <common-page card-content>
        <query-view ref="jscList" :config-code="$_configCode"
                    :filter="filter"
                    custom-columns="id"
                    disable-export enable-edit
                    :disable-edit-btn="2"
                    with-custom-actions-head-of-row>
            <template #leftHeader>
                <mini-button name="add#" @btnClick="openEdit(null)">
                    <i class="fa-solid fa-plus"></i>
                </mini-button>
                <mini-button @btnClick="importConfigs">Import</mini-button>
                <mini-button :disable="$_notChecked" @btnClick="copyConfigs">Export/Copy</mini-button>
            </template>
            <template #custom(id)="{row}">
                <IdRecode v-if="row.id" class="mr-1" :id="row.id" :service="row.moduleCode" :code-config="codeIdMap" @saved="queryCodeIdMap"/>
            </template>
            <template #headOfRow="{row}">
                <mini-button name="edit#" @btnClick="openEdit(row)">
                    <i class="fa-solid fa-pen-to-square"></i>
                </mini-button>
            </template>
        </query-view>

        <template #outer>
            <re-b-modal ref="jsonInput" header="粘贴配置"
                        :no-ok-button="coping"
                        @ok="parseConfigJson(copiedJsonStr)"
                        @hide="copiedJsonStr=null;coping=false;">
                <mini-input type="textarea" class="m-auto"
                            :value.sync="copiedJsonStr"
                            without-label></mini-input>
            </re-b-modal>
            <re-b-modal ref="jsonView" header="JSON查看" ok-label="上传" @ok="uploadJson">
                <vue-json-pretty :data="copiedJson" :deep="5"></vue-json-pretty>
            </re-b-modal>

            <re-b-modal ref="configModal" super-large hide-footer hide-header>
                <query-config ref="queryConfig" single-mode style="min-height: 400px"
                              @saved="$refs.jscList.queryRows()"></query-config>
            </re-b-modal>
        </template>
    </common-page>
</template>

<script>
import CommonPage from "@/components/echarts-part/stuff/CommonPage.vue";
import QueryView from "@/components/common/display/query-view/QueryView.vue";
import IdRecode from "@/components/jsc/qc-cell/stuff/IdRecode.vue";
import MiniButton from "@/components/common/buttons/MiniButton.vue";
import miniTableCheckedMixin from "@/mixin/em/common/stuffs/table/miniTableCheckedMixin";
import MiniInput from "@/components/common/inputs/MiniInput.vue";
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal.vue";
import VueJsonPretty from 'vue-json-pretty';
import QueryConfig from "@/components/jsc/QueryConfig.vue";
import {DICT_TYPE} from "@/plugins/configure-query-helper";

export default {
    name: "QCTablePage",
    components: {QueryConfig, ReBModal, MiniInput, MiniButton, IdRecode, QueryView, CommonPage, VueJsonPretty},
    mixins: [miniTableCheckedMixin],
    data() {
        return {
            filter: {
                identifyCode: 'query-config',
            },
            copiedJsonStr: null,
            copiedJson: null,
            coping: false,

            codeIdMap: [],
        }
    },
    computed: {
        $_configCode() {
            return "jsc";
        },
    },
    mounted() {
        this.queryCodeIdMap();
    },
    methods: {
        //-------------------------------------------
        copyConfigs() {
            if (this.$_notChecked) {
                this.$message.warning('You should select first');
                return;
            }
            let json = JSON.stringify(this.checkedRows.map(row => this.withConfigCode(row)));
            if (navigator.clipboard) {
                navigator.clipboard.writeText(json);
                this.$message.success("Copied");
            } else {
                this.copiedJsonStr = json;
                this.coping = true;
                this.$refs.jsonInput.showModal();
            }
        },
        importConfigs() {
            if (navigator.clipboard) {
                navigator.clipboard.readText().then(json => {
                    this.parseConfigJson(json);
                });
            } else {
                this.$refs.jsonInput.showModal();
            }
        },
        parseConfigJson(json) {
            try {
                this.copiedJson = JSON.parse(json);
                this.$refs.jsonView.showModal();
            } catch (error) {
                this.$message.error('拷贝内容格式错误：' + error);
            }
        },
        uploadJson() {
            let rows = Array.isArray(this.copiedJson) ? this.copiedJson : [this.copiedJson];
            this.$store.dispatch('api/post', {
                url: `${process.env.VUE_APP_EM_ASSISTANT_URL}/jscConfiguration/upload/copied`,
                // configCode 不是 JscConfiguration 的字段，它只描述 config_map_code 映射，上传前剥掉
                data: rows.map(row => this.withoutConfigCode(row))
            }).then(() => this.restoreConfigCodes(rows)).then(() => {
                this.$message.success("Upload success");
                this.$refs.jscList.queryRows();
                this.copiedJson = null;
            });
        },
        //------------------- config code ----------------------
        // 导出时把 config_map_code 里的编码一起带出：配置在目标环境会拿到新的 id，
        // 只有带上编码，导入方才能把 code→moduleCode:id 的映射重新指过去。
        withConfigCode(row) {
            return {...row, configCode: this.findConfigCode(row)};
        },
        findConfigCode(row) {
            if (!row || !this.hasCode(row.id) || !this.hasCode(row.moduleCode)) {
                return null;
            }
            let value = `${row.moduleCode}:${row.id}`;
            let hit = this.codeIdMap.find(item => item.value === value);
            return hit ? hit.name : null;
        },
        withoutConfigCode(row) {
            let temp = {...row};
            delete temp.configCode;
            return temp;
        },
        // 导入后按后端的唯一性口径（identifyCode + key + title + shareLevel）找回本环境的 id，
        // 再把 config code 指向它。
        restoreConfigCodes(rows) {
            let coded = rows.filter(row => row && this.hasCode(row.configCode));
            if (coded.length === 0) {
                return Promise.resolve();
            }
            return Promise.all([
                this.queryCodeIdMap().catch(() => null),
                ...coded.map(row => this.queryUploadedConfig(row)),
            ]).then(res => this.saveConfigCodes(coded, res.slice(1)));
        },
        queryUploadedConfig(row) {
            let identifyCode = this.emptyToDefault(row.identifyCode, '');
            let key = this.emptyToDefault(row.key, '');
            let url = `${process.env.VUE_APP_EM_ASSISTANT_URL}/jscConfiguration/visibleList`
                + `?identifyCode=${encodeURIComponent(identifyCode)}&key=${encodeURIComponent(key)}`;
            // 后端 uploadByUserCopy 只会落到 PRIVATE / GLOBAL 两档，其余共享级别都按 PRIVATE 匹配
            let shareLevel = Number(row.shareLevel) === 20 ? 20 : 1;
            return this.$store.dispatch('api/get', {url, commonErrorHandle: false})
                .then(list => {
                    let hit = (list || []).filter(item => item.shareLevel === shareLevel
                        && (!this.hasCode(row.title) || item.title === row.title));
                    return hit.length === 1 ? hit[0] : null;
                }).catch(() => null);
        },
        saveConfigCodes(rows, configs) {
            let editRows = [];
            let missing = [];
            let privates = [];
            let handled = [];
            rows.forEach((row, index) => {
                let code = row.configCode;
                if (handled.includes(code)) {
                    return;
                }
                handled.push(code);
                let config = configs[index];
                if (!config || !this.hasCode(config.id) || !this.hasCode(config.moduleCode)) {
                    missing.push(code);
                    return;
                }
                // 后端只允许 code 指向公共配置，私有的混在一批里会让整批映射失败，先挑出来
                if (config.shareLevel !== 20) {
                    privates.push(code);
                    return;
                }
                let value = `${config.moduleCode}:${config.id}`;
                let exist = this.codeIdMap.find(item => item.name === code);
                if (!exist) {
                    editRows.push({name: code, value});
                } else if (exist.value !== value) {
                    editRows.push({...exist, value});
                }
            });
            if (missing.length > 0) {
                this.$message.warning('以下 config code 未能定位到配置，请手动维护：' + missing.join(', '));
            }
            if (privates.length > 0) {
                this.$message.warning('以下 config code 对应私有配置，Code 只能指向公共配置，请先设为公共：' + privates.join(', '));
            }
            if (editRows.length === 0) {
                return Promise.resolve();
            }
            return this.$store.dispatch('api/post', {
                url: `${this._baseUrl('emDictData')}simple/${DICT_TYPE}/edit`,
                data: {editRows}
            }).then(() => this.queryCodeIdMap());
        },
        //-------------------------------------------
        openEdit(config) {
            this.$refs.configModal.showModal();
            this.$nextTick(() => this.$refs.queryConfig.load(config));
        },
        //-------------------------------------------
        queryCodeIdMap() {
            return this.$store.dispatch('dictionaryEnumStore/getDictOriginal', DICT_TYPE)
                .then(res => {
                    this.codeIdMap = res || [];
                    return this.codeIdMap;
                });
        },
        //-------------------------------------------
    }
}
</script>

<style scoped>

</style>
